<template>
  <Modal
    :id="'cmp-catalog-tracks-main_catalog_alert_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">
      <div style="display: flex; flex-direction: column">
        {{$t('select_main_catalog_no')}}
        <span>
          {{$t('please_select_the_main_product')}}
        </span>
      </div>
    </template>
    <template slot="body">
      <SearchList
        style="padding-bottom: 10px"
        :id="'product_id'"
        ref="searchList"
        :items="list"
        :keyProperty="'product_id'"
        :label="'product_id'"
        :showSelectAll="false"
        :headers="[
          { text: 'catalog_no' },
          { text: 'release_artist' },
          { text: 'release_title' },
        ]"
        @searched="searchRelatedProducts"
      >
        <template v-slot:item="{ item }">
          <tr @click="onSelected(item)" class="dt-table2--row">
            <dt
              class="dt-table2--column"
              style="border-right: 1px solid #fefefe"
            >
              <span class="txtov">{{ item.catalog_no }}</span>
            </dt>

            <dt class="dt-table2--column">
              <span class="txtov">{{ item.release_artist }}</span>
            </dt>
            <dt class="dt-table2--column">
              <span class="txtov">{{ item.release_title }}</span>
            </dt>
          </tr>
        </template>
      </SearchList>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("close") }}
      </button>
    </template>
  </Modal>
</template>
    
    <script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { TracksService } from "../../services/tracks.service";
import { Subject } from "rxjs";
import NTable from "@/plugins/datatable/datatable";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { async } from "ramda-adjunct";
export default {
  components: {
    Modal,
    SearchList,
    InputField,
    NTable,
  },
  props: ["selectedTrack"],
  data() {
    return {
      products: [],
      searchString: "",
    };
  },
  mounted: async function () {
    const res = await TracksService.getRelatedProducts(this.track_id);
    this.products = res.data.products;
  },
  computed: {
    list: function () {
      return this.products;
    },
    track_id: function () {
      return this.$route.query.track_id;
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onSelected: async function (payload) {
      const res = await TracksService.setMainProduct({
        product_id: payload.product_id,
        track_id: this.track_id,
      });
      this.onCancel();
    },
    searchRelatedProducts: function (searchString) {
      this.searchString = searchString;
      TracksService.searchRelatedProducts(searchString).then((res) => {
        this.products = res.data.products;
      });
    },
  },
};
</script>
  <style lang="scss">
.cmp-catalog-tracks-main_catalog_alert_modal {
  .dt-table2--column {
    padding-left: 5px;
  }
  .dt-table2 {
    --row-margin-header: none;
  }
  .dt-modal--header div span {
    color: rgba(0, 0, 0, 0.87) !important;
    text-transform: none !important;
    font-size: 13px !important;
  }
}
</style>
  
    